/**
 * エラー画面のルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import ErrorAuth from '../views/error/ErrorAuth.vue'
import Error400 from '../views/error/Error400.vue'
import Error401 from '../views/error/Error401.vue'
import Error404 from '../views/error/Error404.vue'
import Error409 from '../views/error/Error409.vue'
import Error423 from '../views/error/Error423.vue'
import Error500 from '../views/error/Error500.vue'

/**
 * エラーページ群
 */
const errorRoutes: Array<RouteConfig> = [
  // 認証エラー
  {
    path: '/error/auth',
    name: 'ErrorAuth',
    component: ErrorAuth,
  },
  // 400エラー
  {
    path: '/error/400',
    name: 'Error400',
    component: Error400,
  },
  // 401エラー
  {
    path: '/error/401',
    name: 'Error401',
    component: Error401,
  },
  // 404エラー
  {
    path: '/error/404',
    name: 'Error404',
    component: Error404,
  },
  // 409エラー
  {
    path: '/error/409',
    name: 'Error409',
    component: Error409,
  },
  // 423エラー
  {
    path: '/error/423',
    name: 'Error423',
    component: Error423,
  },
  // 500エラー
  {
    path: '/error/500',
    name: 'Error500',
    component: Error500,
  },
]

export default errorRoutes
